import styled from 'styled-components'
import ZoomingAnimation from './partials/ZoomingAnimation'

function Pulsing() {
    return (
        <Container>
            <ZoomingAnimation />
        </Container>
    )
}

const Container = styled.div`
    min-height: 100vh;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
`

export default Pulsing
